import { Input } from "@/components/ui/input";

export default function TeamNavigation({
  searchQuery,
  setSearchQuery,
}: {
  searchQuery: string;
  setSearchQuery: (searchQuery: string) => void;
}) {
  return (
    <div className="flex flex-row items-center gap-4">
      {/* Search */}
      <div className="relative">
        <Input
          type="text"
          placeholder="Search for user..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="!placeholder:text-neutral-800 h-[45px] w-full bg-neutral-100 pr-4 pl-12 text-sm leading-normal font-medium !text-neutral-800"
        />
        <i className="ri-search-line absolute top-1/2 left-3 -translate-y-1/2 text-gray-500"></i>
      </div>
    </div>
  );
}
